// extracted by mini-css-extract-plugin
module.exports = {"widget":"Widget_widget__1RtDV","title":"Widget_title__2rDkh"};